// src/hooks/useIikoCloudStatus.js
// Есть ли у активного сервера рабочее подключение iikoCloud — от этого зависят пункты меню
// отчётов iikoCloud («Кухня», вкладка «Склад» в «Себестоимости»). Запрос при смене сервера; ответ по серверу хранится на время сессии
// (в памяти вкладки), чтобы шапка и нижняя навигация не спрашивали по отдельности.
// null — ещё не знаем (пункт меню не показываем), true/false — ответ бэкенда.
import { useEffect, useState } from 'react';
import { fetchIikoCloudStatus } from '../services/dataService';

const cache = new Map(); // serverId → boolean
const pending = new Map(); // serverId → Promise<boolean>

function activeServerId() {
  try {
    return JSON.parse(localStorage.getItem('activeServer') || 'null')?.id ?? null;
  } catch {
    return null;
  }
}

function load(serverId) {
  if (cache.has(serverId)) return Promise.resolve(cache.get(serverId));
  if (pending.has(serverId)) return pending.get(serverId);
  const token = localStorage.getItem('token');
  const promise = (token ? fetchIikoCloudStatus(token) : Promise.resolve(false))
    .then((value) => {
      cache.set(serverId, value);
      return value;
    })
    // Не узнали — пункт не показываем, но и не запоминаем: спросим при следующей смене сервера
    .catch(() => false)
    .finally(() => pending.delete(serverId));
  pending.set(serverId, promise);
  return promise;
}

export function useIikoCloudStatus() {
  const [serverId, setServerId] = useState(activeServerId);
  const [status, setStatus] = useState(() => (serverId !== null && cache.has(serverId) ? cache.get(serverId) : null));

  useEffect(() => {
    const update = () => setServerId(activeServerId());
    window.addEventListener('activeServerChanged', update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener('activeServerChanged', update);
      window.removeEventListener('storage', update);
    };
  }, []);

  useEffect(() => {
    if (serverId === null) {
      setStatus(false);
      return undefined;
    }
    let alive = true;
    setStatus(cache.has(serverId) ? cache.get(serverId) : null);
    load(serverId).then((value) => alive && setStatus(value));
    return () => {
      alive = false;
    };
  }, [serverId]);

  return status;
}
